import { CircularProgress } from '@mui/material'
import clsx from 'clsx'
import { Typography } from 'components/typography'
import { ParentTableProps, ReachTableProps, TypographyTypes } from 'interfaces'
import React, { useState } from 'react'
import { MyReachTable } from './myReachTable'

const ReachTable: React.FC<ParentTableProps<ReachTableProps>> = ({
	data,
	page,
	setPage,
	isLoading,
	className,
	isOrder,
	dataNotification,
	dataSelected,
	setDataSelected,
	refetch,
	onShowingItemsChange,
	onShowingItems,
	setReachOpenSlide,
	classNameLoading
}) => {
	const [loading, setLoading] = useState(false)

	const spaceColums = dataNotification ? [50, 66, 30] : [50, 66, 30]

	const headers = ['Name', 'Email', 'Tags']

	if (loading || isLoading) {
		return (
			<div className={clsx(className, 'flex flex-col w-full')}>
				<div
					className={clsx(
						'flex items-center justify-center w-full h-[calc(100vh-_446px)] py-2 px-1 bg-white border-2 border-gray-7 rounded-lg'
					)}
				>
					<CircularProgress disableShrink />
				</div>
			</div>
		)
	}

	return (
		<div className={clsx(className, 'flex flex-col w-full')}>
			{data?.items?.length ? (
				<div className="overflow-x-auto">
					<MyReachTable
						data={data?.items || []}
						backendPages={data?.pages}
						page={page}
						headers={headers}
						customWidth={spaceColums}
						actionColumnWidth={4}
						bodyTableClassName="h-[calc(100vh-_480px)]"
						justify="left"
						setPage={setPage}
						dataSelected={dataSelected}
						setDataSelected={setDataSelected}
						refetch={refetch}
						dataNotification={dataNotification}
						setLoading={setLoading}
						isOrder={isOrder}
						onShowingItemsChange={onShowingItemsChange}
						onShowingItems={onShowingItems}
						setReachOpenSlide={setReachOpenSlide}
					/>
				</div>
			) : (
				<div
					className={clsx(
						classNameLoading,
						'flex items-center justify-center w-full h-[calc(100vh_-_446px)] py-2 px-1 bg-white border-2 border-gray-7 rounded-lg'
					)}
				>
					<Typography
						title="You don't have any people to export."
						type={TypographyTypes.h3}
						fontLeading="18/21"
						className="text-gray-7"
					/>
				</div>
			)}
		</div>
	)
}

export default ReachTable
